import LoadingButton from "@mui/lab/LoadingButton";
import React from "react";
import {useSelector} from "react-redux";
import {SUBMITTING} from "../../actions/app-state-action";

export default function SubmitButton(props) {
    const {state} = useSelector((state) => state.appState)
    return (
        <LoadingButton
            loading={state == SUBMITTING}
            {...props}
        >
            {props.children}
        </LoadingButton>
    );
}